var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.steps.length
    ? _c(
        "div",
        { staticClass: "row mb-3" },
        _vm._l(_vm.steps, function(step, index) {
          return _c("div", { key: "step-" + index, staticClass: "col-3" }, [
            _c("div", { staticClass: "step-wrapper" }, [
              _c("span", { staticClass: "step-number" }, [
                _vm._v(_vm._s(step.numeroPaso))
              ]),
              _c("div", { staticClass: "text-center step-name" }, [
                _vm._v(" " + _vm._s(step.responsable) + " "),
                _c("div", [
                  step.desdePrecio
                    ? _c("small", [
                        _c("b", [
                          _vm._v(
                            _vm._s(step.desdePrecio) +
                              " " +
                              _vm._s(step.desdePrecioMoneda)
                          )
                        ])
                      ])
                    : _vm._e()
                ])
              ]),
              _c("div", { staticClass: "step-type" }, [
                step.distributed == 1
                  ? _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip",
                            value:
                              "Distribuido: se asigna a 1 persona del grupo secuencialmente",
                            expression:
                              "'Distribuido: se asigna a 1 persona del grupo secuencialmente'"
                          }
                        ],
                        staticClass: "mr-1"
                      },
                      [
                        _c("vs-icon", {
                          attrs: {
                            icon: "share",
                            size: "12px",
                            color: "warning"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                step.aprobacionesTipoPasoId === _vm.stepTypes.USER.toString()
                  ? _c("span", [_vm._v(" usuario ")])
                  : _vm._e(),
                step.aprobacionesTipoPasoId === _vm.stepTypes.OFFICE.toString()
                  ? _c("span", [_vm._v(" oficina ")])
                  : _vm._e(),
                step.aprobacionesTipoPasoId === _vm.stepTypes.GROUP.toString()
                  ? _c("span", [_vm._v(" grupo ")])
                  : _vm._e(),
                step.aprobacionesTipoPasoId ===
                _vm.stepTypes.USER_SEND_APPROVAL.toString()
                  ? _c("span", [
                      _vm._v(" usuario"),
                      _c("br"),
                      _vm._v("aprobación ")
                    ])
                  : _vm._e(),
                step.aprobacionesTipoPasoId ===
                _vm.stepTypes.LEADERSHIP_SENDING_APPROVAL.toString()
                  ? _c("span", [
                      _vm._v(" J. usuario"),
                      _c("br"),
                      _vm._v("aprobación ")
                    ])
                  : _vm._e(),
                step.aprobacionesTipoPasoId ===
                _vm.stepTypes.GROUP_LEADER_SENDING_APPROVAL.toString()
                  ? _c("span", [
                      _vm._v(" L. usuario"),
                      _c("br"),
                      _vm._v("aprobación ")
                    ])
                  : _vm._e(),
                step.aprobacionesTipoPasoId ===
                _vm.stepTypes.PERSON_FROM_DOC_PRE_DEFINED.toString()
                  ? _c("span", [
                      _vm._v(" Desde "),
                      _c("br"),
                      _vm._v("Archivo ")
                    ])
                  : _vm._e()
              ]),
              _c("div", { staticClass: "step-rol" }, [
                step.aprobacionesTipoRolId === _vm.rolTypes.APPROVER.toString()
                  ? _c("span", [_vm._v(" aprobador ")])
                  : _vm._e(),
                step.aprobacionesTipoRolId === _vm.rolTypes.SIGNER.toString() &&
                step.aprobacionesTipoPasoId !== _vm.stepTypes.OFFICE.toString()
                  ? _c("span", [_vm._v(" firmante ")])
                  : _vm._e(),
                step.aprobacionesTipoRolId === _vm.rolTypes.SIGNER.toString() &&
                step.aprobacionesTipoPasoId === _vm.stepTypes.OFFICE.toString()
                  ? _c("span", [_vm._v(" Numerar/tramitar ")])
                  : _vm._e(),
                step.aprobacionesTipoRolId ===
                _vm.rolTypes.CONFIGURATOR.toString()
                  ? _c("span", [_vm._v(" configurador ")])
                  : _vm._e(),
                step.aprobacionesTipoRolId === _vm.rolTypes.REVIEWER.toString()
                  ? _c("span", [_vm._v(" revisor ")])
                  : _vm._e()
              ])
            ])
          ])
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }